import styled from 'styled-components'
import { UsernameInitials } from 'sutra/components/UsernameInitials'
import { accents, gray } from 'sutra/tokens/colors'

import { askYogiTokens as t } from 'features/ask-yogi/styles/tokens'

// The card's overflow menu, the last item in HeaderRow so it lines up with
// the chips instead of floating over them.
export const KebabSlot = styled.div`
  display: flex;
  flex-shrink: 0;
  margin-left: auto;
`

// Asymmetric corners give the box a speech-bubble read: the top-left corner
// (nearest the avatar in the header row) is squared off, the other three
// are rounded. The border used to live on QuoteBox alone; it's on the whole
// card now, with HeaderRow/QuoteBox as plain unbordered flex children.
export const Card = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: ${t.spacing.sm} 0;
  border: 1px solid ${t.color.divider};
  border-radius: 4px 14px 14px;
`

// Fixed 24px, not one of UsernameInitials' sm/md/lg presets (22/28/30) —
// a local override via styled() rather than touching the shared component's
// preset table, which 7 other consumers rely on.
export const SmallInitials = styled(UsernameInitials)`
  && {
    width: 24px;
    height: 24px;
    font-size: 10px;
  }
`

export const HeaderRow = styled.div<{ $compact?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${t.spacing.sm};
  flex-wrap: ${({ $compact }) => ($compact ? 'wrap' : 'nowrap')};
  padding: 0 ${t.spacing.sm};
`

export const NameAndSource = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: ${t.color.text};

  .name {
    font-weight: ${t.fontWeight.emphasis};
  }

  .source {
    color: ${t.color.muted};
  }
`

export const StarRow = styled.div`
  display: flex;
  flex-shrink: 0;
  gap: 1px;
`

export const Star = styled.span<{ $filled: boolean }>`
  color: ${({ $filled }) => ($filled ? accents.goldenLight[500] : gray[300])};
  font-size: 13px;
  line-height: 1;
`

export const DateLabel = styled.div`
  font-size: ${t.fontSize.caption};
  color: ${gray[400]};
  white-space: nowrap;
`

export const QuoteBox = styled.div`
  padding: 0 ${t.spacing.md};
  font-size: 14px;
  line-height: ${t.lineHeight.body};
  color: ${t.color.text};
  overflow-wrap: anywhere;
`

// Block-level so the title always starts its own line above the body —
// a bare <strong> is inline and runs straight into the body text with no
// separator.
export const RecordTitle = styled.div`
  font-weight: ${t.fontWeight.emphasis};
  margin-bottom: ${t.spacing.xs};
`

export const ChipRow = styled.div`
  display: flex;
  flex-shrink: 0;
  gap: ${t.spacing.xs};
  margin-left: auto;
`

// Date (left) and the badge group (flex-end) on one row, inside QuoteBox.
export const MetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${t.spacing.xs};
  margin-top: ${t.spacing.xs};
`

export const IconRow = styled.div`
  display: flex;
  margin-left: auto;
`

export const SkeletonBar = styled.div<{ $width: string }>`
  width: ${({ $width }) => $width};
  height: 12px;
  border-radius: 4px;
  background: ${t.color.iconBg};
`
